import { Typography } from '@material-ui/core';
import { useUID } from '@superdispatch/ui';
import { PoundIcon } from 'shared/icons';
import styled from 'styled-components';

interface PostingNumberProps {
  postingNumber: string;
}

const Styled1 = styled.div`
  display: flex;
  align-items: flex-start;
`;
const Styled2 = styled.div`
  margin-right: 8px;
`;

export function PostingNumber({ postingNumber }: PostingNumberProps) {
  const id = useUID();
  return (
    <Styled1>
      <Styled2>
        <PoundIcon fontSize="small" color="action" />
      </Styled2>
      <Typography id={id} color="textSecondary" noWrap={true}>
        Load ID
      </Typography>
      &nbsp;
      <Typography aria-labelledby={id}>{postingNumber}</Typography>
    </Styled1>
  );
}
